(() => {
  const SECTION_SELECTOR = '[data-section-type="w-form"]';

  class WFormSection {
    constructor(section) {
      this.section = section;
      this.dateWraps = Array.from(section.querySelectorAll('[data-w-form-date-wrap]'));
      this.phoneInputs = Array.from(section.querySelectorAll('[data-w-form-phone-input]'));
      this.form = section.querySelector('.w-form__form');
      const returnToInput = this.form
        ? this.form.querySelector('input[name="return_to"]')
        : null;
      this.successUrl =
        (returnToInput && returnToInput.value) || '/pages/page-confirmation-contact-pro';
      this.bindDateFields();
      this.bindPhoneFields();
      this.bindSubmit();
    }

    bindDateFields() {
      this.dateWraps.forEach((wrap) => {
        const input = wrap.querySelector('[data-w-form-date-input]');
        const trigger = wrap.querySelector('[data-w-form-date-trigger]');
        if (!input) return;

        const syncState = () => {
          wrap.classList.toggle('has-value', Boolean(input.value));
        };

        const openPicker = () => {
          input.focus();
          if (typeof input.showPicker === 'function') {
            input.showPicker();
          }
        };

        if (trigger) {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            openPicker();
          });
        }

        input.addEventListener('click', () => {
          openPicker();
        });

        input.addEventListener('input', syncState);
        input.addEventListener('change', syncState);
        syncState();
      });
    }

    bindPhoneFields() {
      this.phoneInputs.forEach((input) => {
        const sanitizeValue = () => {
          const digitsOnly = input.value.replace(/\D+/g, '').slice(0, 10);
          if (input.value !== digitsOnly) {
            input.value = digitsOnly;
          }
        };

        input.addEventListener('input', sanitizeValue);
        input.addEventListener('change', sanitizeValue);
        input.addEventListener('blur', sanitizeValue);
        input.addEventListener('paste', () => {
          window.requestAnimationFrame(sanitizeValue);
        });

        sanitizeValue();
      });
    }

    bindSubmit() {
      if (!this.form) return;

      this.form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (this.form.dataset.wFormSubmitting === 'true') return;
        this.form.dataset.wFormSubmitting = 'true';

        const submitButton = this.form.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
        }

        const action = '/contact';
        const method = 'POST';
        const formData = new FormData(this.form);

        const emailInput = this.form.querySelector('input[name="contact[email]"]');
        if (emailInput && emailInput.value) {
          document.cookie = 'b2b_pro_email=' + encodeURIComponent(emailInput.value) + ';path=/;max-age=300;SameSite=Lax';
        }

        try {
          const response = await fetch(action, {
            method,
            body: formData,
            credentials: 'same-origin',
            redirect: 'follow',
          });

          if (
            response.url.includes('contact_posted=true') ||
            response.url.includes(this.successUrl)
          ) {
            window.location.href = this.successUrl;
            return;
          }
        } catch (error) {}

        this.form.dataset.wFormSubmitting = 'false';
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
    }
  }

  const instances = new Map();

  function getKey(section) {
    return section.dataset.sectionId || section.id;
  }

  function initSections(scope = document) {
    const sections =
      scope.matches && scope.matches(SECTION_SELECTOR)
        ? [scope]
        : scope.querySelectorAll(SECTION_SELECTOR);

    sections.forEach((section) => {
      const key = getKey(section);
      if (instances.has(key)) return;
      instances.set(key, new WFormSection(section));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', (event) => initSections(event.target));
})();
